import { Pipe, PipeTransform } from '@angular/core';
import { PartnerGatewayEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/partner-gateway-enum';
@Pipe({
    name: 'partnerGateway',
    standalone: false
})
export class PartnerGatewayPipe implements PipeTransform {
  transform(value: PartnerGatewayEnum) {
    switch (value) {
      case PartnerGatewayEnum.ExpandIt:
        return 'ExpandIt';
      case PartnerGatewayEnum.Gastech:
        return 'Gastech';
    }
    return value;
  }
}
